import { Pagination, Spinner } from '~/ui';
import { Board } from '../Shared/Layout/Board/Board';
import { useState } from 'react';
import { Action } from '~/ui/Actions';
import AddIcon from '~/assets/svg/newSvg/actions/add.svg?react';
import { useTranslation } from 'react-i18next';
import styles from './LeisureTournament.module.scss';
import TournamentTable from './TournamentTable/TournamentTable';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { instance } from '~/utils/api/api';
import { useToastSuccess } from '~/utils/useToastSuccess';
import { useToastError } from '~/utils/useToastError';
import { getPaginate } from '~/utils/getPaginate';

const LeisureTournament = ({ gameId }: { gameId: number }) => {
  const { paginate } = getPaginate();
  const [page, setPage] = useState(paginate);
  const [sort, setSort] = useState({ field: '', direction: '' });
  const toastSuccess = useToastSuccess();
  const toastError = useToastError();
  const client = useQueryClient();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: tournaments, isLoading } = useQuery({
    queryFn: async () => {
      const { data } = await instance.get(`admin/game-tournament`, {
        params: {
          game_id: gameId,
          page,
          sort: sort.direction,
          field: sort.field,
        },
      });
      return data;
    },
    queryKey: ['game-tournaments', gameId, page, sort],
  });

  const { mutateAsync: deleteTournament } = useMutation(
    async (id: number) => {
      const response = await instance.delete(`admin/game-tournament/${id}`);
      return response;
    },
    {
      onSuccess: () => {
        toastSuccess(t('tournament_successfully_deleted'));
        client.invalidateQueries(['game-tournaments', gameId]);
      },
      onError: error => {
        toastError(error);
      },
    }
  );

  return (
    <Board classNames={styles.board}>
      <div className={styles.actionWrapper}>
        <Action variant="success" onClick={() => navigate('create')}>
          <AddIcon />
          {t('add_tournament')}
        </Action>
      </div>
      {tournaments && !isLoading ? (
        <TournamentTable
          paginate={paginate.toString()}
          sort={sort}
          setSort={setSort}
          tournaments={tournaments?.data}
          deleteTournament={deleteTournament}
        />
      ) : (
        <Spinner />
      )}
      <Pagination
        forcePage={paginate}
        pageCount={tournaments?.last_page}
        onPageChange={(selectedPage: { selected: number }) => {
          setPage(selectedPage.selected + 1);
        }}
      />
    </Board>
  );
};
export default LeisureTournament;
